import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../../service/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { AccountPageData } from '../../../model/AccountPageData';
import { BsModalService } from 'ngx-bootstrap/modal';
import { UpdateAccountComponent } from './update-account/update-account.component';
import { Account } from '../../../model/Account';
import { Group } from '../../../model/Group';
import { UpdateGroupComponent } from './update-group/update-group.component';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { AccountPageService } from '../../../service/account-page.service';
import { DarkModeService } from '../../../service/dark-mode.service';
import { UtilsService } from '../../../service/utils.service';

@Component({
  selector: 'ch-accounts',
  templateUrl: './accounts.component.html'
})
export class AccountsComponent implements OnInit {

  @ViewChild('staticTabs', { static: false }) staticTabs?: TabsetComponent;
  statusAccount: boolean = true;
  statusGroup: boolean = false;

  accountOrder = {};
  groupOrder = {};

  preload: AccountPageData;

  title: string;

  constructor(private readonly authenticationService: AuthenticationService,
              private readonly activatedRoute: ActivatedRoute,
              private readonly modalService: BsModalService,
              public readonly darkModeService: DarkModeService,
              private readonly accountService: AccountPageService
  ) { }

  ngOnInit(): void {
    this.preload = this.activatedRoute.snapshot.data['preload'];
    this.title = 'Account Name & Email addresses';
  }

  setAccountOrder(value: string) {
    const existingOrders = Object.keys(this.accountOrder).length;
    if (!Object.keys(this.accountOrder).includes(value) || this.accountOrder[value].value === 0) {
      this.accountOrder[value] = {value: 1, order: this.accountOrder[value] ? this.accountOrder[value].order : existingOrders + 1};
      // this.initFilteredAndOrderedList();
      return;
    }

    if (this.accountOrder[value].value === 1) {
      this.accountOrder[value] = {value: -1, order: this.accountOrder[value] ? this.accountOrder[value].order : existingOrders + 1};
      // this.initFilteredAndOrderedList();
      return;
    }
    // this.accountOrder[value] = {value: 0, order: this.accountOrder[value] ? this.accountOrder[value].order : existingOrders + 1};

    Object.keys(this.accountOrder).forEach(k => {
      if (k === value) {
        return;
      }

      if (this.accountOrder[value].order < this.accountOrder[k].order) {
        this.accountOrder[k].order--;
      }
    });
    delete this.accountOrder[value];
    // this.initFilteredAndOrderedList();
    // this.accountOrder[value] = 0;
  }

  setGroupOrder(value: string) {
    const existingOrders = Object.keys(this.groupOrder).length;
    if (!Object.keys(this.groupOrder).includes(value) || this.groupOrder[value].value === 0) {
      this.groupOrder[value] = {value: 1, order: this.groupOrder[value] ? this.groupOrder[value].order : existingOrders + 1};
      // this.initFilteredAndOrderedList();
      return;
    }

    if (this.groupOrder[value].value === 1) {
      this.groupOrder[value] = {value: -1, order: this.groupOrder[value] ? this.groupOrder[value].order : existingOrders + 1};
      // this.initFilteredAndOrderedList();
      return;
    }
    // this.groupOrder[value] = {value: 0, order: this.groupOrder[value] ? this.groupOrder[value].order : existingOrders + 1};

    Object.keys(this.groupOrder).forEach(k => {
      if (k === value) {
        return;
      }

      if (this.groupOrder[value].order < this.groupOrder[k].order) {
        this.groupOrder[k].order--;
      }
    });
    delete this.groupOrder[value];
    // this.initFilteredAndOrderedList();
    // this.order[value] = 0;
  }

  getAccountClass(property: string) {
    if (!this.accountOrder[property]?.value || this.accountOrder[property]?.value === 0) {
      return 'icon-width';
    }
    if (this.accountOrder[property]?.value === -1) {
      return 'fa-angle-up';
    }
    return 'fa-angle-down';
  }


  getGroupClass(property: string) {
    if (!this.groupOrder[property]?.value || this.groupOrder[property]?.value === 0) {
      return 'icon-width';
    }
    if (this.groupOrder[property]?.value === -1) {
      return 'fa-angle-up';
    }
    return 'fa-angle-down';
  }

  updateAccount(account: Account) {
    const initialState = {
      account
    };
    const modalRef = this.modalService.show(UpdateAccountComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      class: 'modal-dialog-centered' + UtilsService.getModalDarkModeClass(this.darkModeService),
      animated: false,
      initialState
    });

    modalRef.content.accountUpdateEvent.subscribe(() => {
      // this.accountService.preload().subscribe((preload) => {
      //   this.preload = preload;
      // });
      this.reload();
    });
  }

  updateGroup(group: Group) {
    const initialState = {
      group
    };
    const modalRef = this.modalService.show(UpdateGroupComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      class: 'modal-dialog-centered' + UtilsService.getModalDarkModeClass(this.darkModeService),
      animated: false,
      initialState
    });

    modalRef.content.groupUpdateEvent.subscribe(() => {
      this.reload();
    });
  }

  reload() {
    this.accountService.preload().subscribe((preload) => {
      this.preload = preload;
    });
  }

  selectTab(tabId: number) {
    if (tabId === 0) {
      this.title = 'Account Name & Email addresses';
    } else if (tabId === 1) {
      this.title = 'Group information';
    }
    if (this.staticTabs?.tabs[tabId]) {
      this.staticTabs.tabs[tabId].active = true;
    }
  }

  tabClickAccount(){
    this.statusAccount = !this.statusAccount;
    this.statusGroup = false;
  }

  tabClickGroups(){
    this.statusGroup = !this.statusGroup;
    this.statusAccount = false;
  }
}
